import Quill from 'quill';

import MathBlot from './blot/MathBlot';
import { PrettyLink } from './link/prettyLink';

Quill.register('modules/prettylink', PrettyLink);
Quill.register(MathBlot);
export default Quill;
